import { create } from 'zustand';

export interface PermissionsPromptGate {
  skip: boolean;
  isElectron: boolean;
  noMediaInputSandbox: boolean;
}

/** Suppress permission UI whenever the runtime has already bypassed that contract. */
export const shouldSuppressPermissionsPrompt = ({
  skip,
  isElectron,
  noMediaInputSandbox
}: PermissionsPromptGate): boolean => noMediaInputSandbox || skip || !isElectron;

interface InitialPermissionsCheck {
  readonly complete: boolean;
  readonly answered: boolean;
  markComplete: () => void;
  finishPrompt: () => void;
}

// A first-run check stays pending across the no-dialog interval while native status loads.
// This is per renderer launch, not a persisted grant. Completing a prompt also records the ask as answered.
// Per knowledge: studio.client/trial-welcome-first-run-permission-gap (ai.knowledge).
export const useInitialPermissionsCheck = create<InitialPermissionsCheck>()((set) => ({
  complete: false,
  answered: false,
  markComplete: () => set({ complete: true }),
  finishPrompt: () => set({ complete: true, answered: true })
}));
